export const signInPath = '/sign-in';
export const signUpPath = '/sign-up';
export const newUserPath = '/new-user';
export const homePath = '/home/projects';
export const createOrgPath = '/onboarding/create-org';
